import React from 'react';
import DashboardPage from './DashboardPage';
import LoginPage from './LoginPage';
import { useAuth } from '../Auth';

interface Props {
  // add your props here
}

const HomePage: React.FC<Props> = (
  {
    /* add your prop variables here */
  }
) => {
  const { user } = useAuth();

  // Render ErrorTest component to trigger the error boundary
  return (
    <div>
      {user != null ? <DashboardPage /> : <LoginPage />}
      {/* <div
        className="absolute inset-0 z-0 z-"
        style={{
          backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 2px, #f3f4f6 2px, #f3f4f6 4px)",
        }}
      /> */}
    </div>
  );
};

export default HomePage;
